export default class CustomSelects {
	constructor() {
		this.initialize();
	}

	_select2() {
		$('.js-select2-multiselect').select2();

		$('.js-select2').select2();
	}

	_selecticker() {
		$('.js-selectpicker').selectpicker();
	}

	initialize() {
		this._select2();
		this._selecticker();
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/form/selects.js